<template>
  <div class="form-group">
    <label v-if="label" class="font-size-12">{{ label }}</label>
    <div class="input-container d-flex">
      <input v-model="iValue" type="text" class="form-control" placeholder="https://example.com" :style="{ flex: '1 1 auto' }" />
      <button class="btn-upload" title="Upload" @click="selectFile">
        <b-spinner v-if="loadingUpload" small />
        <i v-else :class="uploadIcon" />
      </button>
      <button class="btn-upload btn-remove" title="Delete" @click="removeImage">
        <i :class="deleteIcon" />
      </button>
      <input ref="inputFile" type="file" name="upload" :style="{ display: 'none' }" accept="image/*" @change="uploadFile($event)" />
    </div>
  </div>
</template>

<script>
import { DELETE_ICON, UPLOAD_ICON } from '@src/icons'
export default {
  props: {
    value: { required: false, type: [String], default: '' },
    label: { type: [String], default: '' }
  },
  data() {
    return {
      deleteIcon: DELETE_ICON,
      uploadIcon: UPLOAD_ICON,
      loadingUpload: false,
      timer: null
    }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newVal) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          let that = this
          let img = new Image()
          img.onload = function() {
            that.$emit('return-data', {
              ShowWidth: this.width,
              ShowHeight: this.height
            })
          }
          img.src = newVal
        }, 500)
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    selectFile() { this.$refs.inputFile.click() },
    uploadFile(event) {
      if (!event.target.files.length) return
      let imageParams = new FormData()
      imageParams.append('file', event.target.files[0])
      this.loadingUpload = true
      this.$store
        .dispatch('image/uploadLogoImage', imageParams)
        .then((response) => {
          this.$emit('input', response.url)
          this.$emit('return-data', response)
          this.loadingUpload = false
        })
        .catch(() => this.loadingUpload = false)
    },
    removeImage() { this.$emit('input', null) }
  }
}
</script>